import gql from 'graphql-tag'

export const ADMIN_SEND_SUBSCRIPTION_NOTIFICATION_MUTATION = gql`
  mutation AdminSendSubscriptionNotification(
    $deviceId: Int!
    $notificationType: String!
    $daysBeforeExpiry: Int
    $reminderNumber: Int
  ) {
    adminSendSubscriptionNotification(
      deviceId: $deviceId
      notificationType: $notificationType
      daysBeforeExpiry: $daysBeforeExpiry
      reminderNumber: $reminderNumber
    )
  }
`
